/**
 * The catalogue's tree, bound to this application's client, for the referential's stock page.
 *
 * « Articles par dépôt » is the referential's and the tree is the catalogue's; a feature
 * never imports another, so the two meet here.
 */

import { CatalogCategoryFilter } from "@hardauto/feature-catalog";
import type { CategoryFilterProps } from "@hardauto/feature-referential";

import { client } from "./api";

export function StockCategoryFilter(props: CategoryFilterProps) {
  return <CatalogCategoryFilter client={client} {...props} />;
}
